
import { Nav } from './components/nav'
import { Gallery } from './components/gallery'
import { Preloader } from './components/preloader'
import { Home } from './pages/home'

// import { PopUp } from './components/popup'
// import { DropDown } from './components/dropdown'

class App {
  constructor() {
    const preloader = new Preloader;
    const nav = new Nav;
    const home = new Home;
    const gallery = new Gallery;

    // if(document.querySelector('.dropdown')) {
    //   const dropdown = new DropDown;
    // }
    // if(document.querySelector('.popup')) {
    //   const popup = new PopUp;
    // }
  }
}

window.onload = function() {
  let app = new App();
};
